import { sseService } from "@/utils/sseService";
import { RefundStatus, SSE_TYPE } from "server/utils/const";
import { emitter } from "@/utils/tool";

/**
 * 全局事件处理器
 */
class GlobalEventHandler {
  private initialized = false;
  private userId: string | null = null;

  /**
   * 初始化全局事件监听
   */
  init(userId: string) {
    // 如果已经初始化并且用户ID相同，则直接返回
    if (this.initialized && this.userId === userId) {
      return;
    }

    // 如果已经初始化但用户ID不同，先销毁再重新初始化
    if (this.initialized) {
      this.destroy();
    }

    this.userId = userId;
    // 初始化SSE连接
    sseService.connect(userId);

    // 注册各种事件监听器
    this.registerEventListeners();

    this.initialized = true;
  }

  /**
   * 注册事件监听器
   */
  private registerEventListeners() {
    // 退款相关事件
    sseService.on(SSE_TYPE.REFUND_UPDATED, (data: any) => {
      this.handleRefundUpdated(data);
    });

    // 消息相关事件
    sseService.on(SSE_TYPE.NOTIFY_UPDATED, (data: any) => {
      this.handleNotificationCreated(data);
    });

    // 订阅相关事件
    sseService.on(SSE_TYPE.SUBSCRIPTION_UPDATED, (data: any) => {
      this.handleSubscriptionUpdated(data);
    });

    // 支付相关事件
    sseService.on(SSE_TYPE.PAYMENT_UPDATED, (data: any) => {
      this.handlePaymentUpdated(data);
    });

    sseService.on("sse_connected", (data: any) => {
      // 连接建立处理
    });
  }

  /**
   * 处理退款更新事件
   */
  private async handleRefundUpdated(data: any) {
    const planStore = usePlanStore();

    // 通知所有相关组件发生了退款更新事件
    emitter.emit(SSE_TYPE.REFUND_UPDATED, data);
    // 根据退款状态显示不同消息
    switch (data.status) {
      case RefundStatus.SUCCESS:
        // 更新用户套餐信息
        await planStore.fetchPlan();
        break;
      case RefundStatus.FAILED:
        break;
      case RefundStatus.PENDING_APPROVAL:
        break;
    }
  }

  /**
   * 处理新消息通知事件
   */
  private handleNotificationCreated(data: any) {
    emitter.emit(SSE_TYPE.NOTIFY_UPDATED, data);
  }

  /**
   * 处理订阅更新事件
   */
  private handleSubscriptionUpdated(data: any) {
    const planStore = usePlanStore();
    planStore.fetchPlan();
    emitter.emit(SSE_TYPE.SUBSCRIPTION_UPDATED, data);
  }

  /**
   * 处理支付更新事件
   */
  private handlePaymentUpdated(data: any) {
    emitter.emit(SSE_TYPE.PAYMENT_UPDATED, data);
    const planStore = usePlanStore();
    planStore.fetchPlan();
  }

  /**
   * 清理资源
   */
  destroy() {
    // 断开SSE连接
    sseService.disconnect();

    this.initialized = false;
    this.userId = null;
  }
}

export const globalEventHandler = new GlobalEventHandler();
